import { SellingMode } from '@src/core/buyerApiClient';

enum SingleBookingPackageStep {
  Calendar = 'calendar',
  Tariff = 'tariff',
  Quantity = 'package_quantity',
  Finish = 'finish',
}

function packageRequiresCalendar(sellingModes: Array<SellingMode>): boolean {
  return sellingModes.some((mode) => mode && mode !== SellingMode.WithoutDate);
}

export function packageRequiresTimeStep(sellingModes: Array<SellingMode>): boolean {
  return sellingModes.some((mode) => mode === SellingMode.WithDateAndTime);
}

export function decidePackageBookingSteps(sellingModes: Array<SellingMode>): SingleBookingPackageStep[] {
  const steps: SingleBookingPackageStep[] = [];

  if (packageRequiresCalendar(sellingModes)) {
    steps.push(SingleBookingPackageStep.Calendar);
  }

  if (packageRequiresTimeStep(sellingModes)) {
    // It's calling tariff step because it's the same as the product adder, but we just render the time selector in the single booking flow
    steps.push(SingleBookingPackageStep.Tariff);
  }

  steps.push(SingleBookingPackageStep.Quantity, SingleBookingPackageStep.Finish);

  return steps;
}
